import { convertAngleToDirection } from "./utils";

export class JoystickDPadHandlerXr {
    constructor(element, outputPrefix) {
        this.angleToDirection = convertAngleToDirection;
        this.outputPrefix = outputPrefix;
        this.centerRadius = 0.6;
        this.previous = "none";
        this.hapticIntensity = "low";
        this.el = element;

        this.emitDPad4 = this.emitDPad4.bind(this);
    }

    addEventListeners() {
        this.el.addEventListener("axismove", this.emitDPad4);
    }

    removeEventListeners() {
        this.el.removeEventListener("axismove", this.emitDPad4);
    }

    emitDPad4(event) {
        const x = event.detail.axis[2];
        const y = event.detail.axis[3];
        const isCenter =
            Math.abs(x) < this.centerRadius && Math.abs(y) < this.centerRadius;
        const direction = isCenter
            ? "center"
            : this.angleToDirection(Math.atan2(x, -y));

        if (direction !== this.previous) {
            this.previous = direction;
            event.target.emit(`${this.outputPrefix}_dpad4_${direction}`);
        }

        if (isCenter) {
            event.target.emit("idle");
        }
    }
}
